import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { useCallback } from 'react';
import { useService } from '~/services/service.base';
import { ServiceBooks } from '~/services/service.books';
import { Book } from '~/views/molecules/book';
import { ServiceCommunity } from '~/services/service.community';
import { ServiceConfig } from '~/services/service.config';
import { useStyles } from '~/views/organisms/shelves/useStyles';
import { getCoverLink } from '~/tools/file';
import { observer } from 'mobx-react-lite';
export const Shelves = observer(({ shelves, clickBookHandler }) => {
    const booksService = useService(ServiceBooks);
    const communityService = useService(ServiceCommunity);
    const serviceConfig = useService(ServiceConfig);
    const classes = useStyles();
    const getShelveBooks = useCallback((shelveId) => {
        return booksService.getShelveBooks(shelveId);
    }, [booksService]);
    return (_jsx(Grid, { container: true, direction: "column", children: shelves.map((shelve, index) => {
            const shelveBooks = getShelveBooks(shelve.id);
            return shelveBooks.length ? (_jsx(Grid, { wrap: "nowrap", className: classes.shelveContainer, container: true, py: 2, children: shelveBooks.map((book, index) => (_jsx(Book, { px: 1, clickImageHandler: clickBookHandler, book: book, coverLink: getCoverLink(book.coverLink, serviceConfig.awsUrl, communityService.currentCommunity?.coverLink || '') }, index))) }, index)) : null;
        }) }));
});
